__webpack_require__.p = "/wp-content/themes/daoudi/dist2/";